export default "__VITE_ASSET__oN6yjael__"